export default __webpack_public_path__ + "static/media/harry.df3e9083.png";